var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BField",
    [
      _c(
        "BAutocomplete",
        {
          ref: "input",
          attrs: {
            data: _vm.invoices,
            placeholder: "UUID",
            field: "uuid",
            value: _vm.invoiceId,
            loading: _vm.loading,
            expanded: "",
            "open-on-focus": ""
          },
          on: {
            select: function(option) {
              return (_vm.selected = option)
            },
            typing: _vm.searchPendingInvoices
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c("div", { staticClass: "media" }, [
                    _c("div", { staticClass: "media-left" }, [
                      _vm._v(
                        "\n          Folio: " +
                          _vm._s(props.option.folio) +
                          "\n        "
                      )
                    ]),
                    _c("div", { staticClass: "media-content" }, [
                      _vm._v(
                        "\n          Total: " +
                          _vm._s(_vm.total(props.option.cfdi)) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n          Nombre: " +
                          _vm._s(props.option.receiverName) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n          RFC: " +
                          _vm._s(props.option.receiverRfc) +
                          " "
                      ),
                      _c("br"),
                      _c("small", [
                        _vm._v(
                          "\n            UUID: " +
                            _vm._s(props.option.uuid) +
                            "\n          "
                        )
                      ])
                    ])
                  ])
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "empty" }, [
            _vm._v(
              "\n      No se encontraron facturas con este criterio.\n    "
            )
          ])
        ],
        2
      ),
      _c(
        "BModal",
        {
          attrs: { active: _vm.modal, "has-modal-card": "" },
          on: {
            "update:active": function($event) {
              _vm.modal = $event
            }
          }
        },
        [_c("Pusher", _vm._b({}, "Pusher", _vm.pusherData, false))],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }